export const CRPAajeevika = 'CRP Aajeevika';

export const areaUnits = [
    'Acre',
    'Hectare',
    'Bigah'
];

export const seasons = [
    'Kharif',
    'Rabi',
    'Zaid'
];

export const productionUnit = [
    'Kg',
    'Quintal',
    'Ton'
];

export const rentalTypes = [
    'Property',
    'Machine',
    'Other'
];

export const LIVELIHOOD_ACTIVITIES_PAGE_URL = '/register/members/livelihoodActivities';

export const QuartersList = [
    {
        label: 'Apr-Jun',
        value: 1
    },
    {
        label: 'Jul-Sept',
        value: 2
    },
    {
        label: 'Oct-Dec',
        value: 3
    },
    {
        label: 'Jan-Mar',
        value: 4
    },
];
export const currentQuarterActive = 2;
export const currentFyYear = '202627';

